import React, {useState} from "react";
import _ from "lodash";
import RenderFields from "../../../common/ui/render-fields";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {BLOG_POST_INPUT_FIELDS} from "../../constants/blog.constant";
import {addSingleBlogPost, updateSingleBlogPost} from "../../services/blog-post-data-service";
import {processBlogPostCategoryConfig} from "../../utils/blog-util";
import {updateSingleContentConfig} from "../../services/content-config-data-service";

const AddEditBlogPost = ({
                                 selectedBlogPost = {},
                                 refreshBlogPostList,
                                 isAddBlogPost = false,
                                 isEditBlogPost = false,
                                 blogPostCategoryConfig,
                                 setBlogPostCategoryConfig
                             }) => {
    const [showModal, setShowModal] = useState(false);
    const [blogPost, setBlogPost] = useState(selectedBlogPost);
    const [saveInProgress, setSaveInProgress] = useState(false);

    const handleConfirmAction = async () => {
        setSaveInProgress(true);

        const existingBlogPost = {...blogPost};

        if (isEditBlogPost) {
            await updateSingleBlogPost(existingBlogPost);
        } else {
            await addSingleBlogPost(existingBlogPost);
        }

        await updateBlogPostCategoryConfig();

        setSaveInProgress(false);
        refreshBlogPostList();
        setShowModal(false);
    }

    const updateBlogPostCategoryConfig = async () => {
        const existingBlogPost: any = {...blogPost};
        processBlogPostCategoryConfig(blogPostCategoryConfig, existingBlogPost.category);
        await updateSingleContentConfig(blogPostCategoryConfig);
        setBlogPostCategoryConfig(blogPostCategoryConfig);
    }

    const handleBlogPostChanges = (event) => {
        const {name, value, type} = event.target;
        const existingBlogPost = {...blogPost};

        if (type === 'checkbox') {
            existingBlogPost[name] = !existingBlogPost[name];
        } else if (type === 'number') {
            existingBlogPost[name] = _.parseInt(value);
        } else {
            existingBlogPost[name] = value;
        }

        prepareBlogPostDetail(existingBlogPost);
        setBlogPost(existingBlogPost);
    }

    const prepareBlogPostDetail = (existingBlogPost) => {
        _.forEach(BLOG_POST_INPUT_FIELDS, (field: any) => {
            if (!_.isEmpty(field.default) && _.isEmpty(existingBlogPost[field.attribute])) {
                existingBlogPost[field.attribute] = field?.default || '';
            }
        });
    }

    return (
        <>
            {isAddBlogPost &&
                <button
                    className="button-green px-3 py-2"
                    onClick={() => setShowModal(true)}>
                    Add Blog Post
                </button>
            }

            {isEditBlogPost &&
                <button
                    className="button-outline-green px-3 py-2"
                    onClick={() => setShowModal(true)}>
                    Edit
                </button>
            }

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-1/2 my-6 mx-auto max-w-3xl">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-gray-100 outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        {isAddBlogPost &&
                                            <>Add Blog Post</>
                                        }

                                        {isEditBlogPost &&
                                            <>Edit Blog Post</>
                                        }
                                    </h3>
                                    <button
                                        className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                        onClick={() => setShowModal(false)}>
                                            <span
                                                className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                              ×</span>
                                    </button>
                                </div>
                                {/*body*/}
                                <div className="relative p-5 flex-auto">
                                    <div className="leading-relaxed">
                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={blogPost}
                                                handleDetailChanges={handleBlogPostChanges}
                                                fieldList={_.groupBy(BLOG_POST_INPUT_FIELDS, 'group')['blog']}
                                                enableEdit={true}
                                                fieldClassName={'w-full'}/>
                                        </div>

                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={blogPost}
                                                handleDetailChanges={handleBlogPostChanges}
                                                fieldList={_.groupBy(BLOG_POST_INPUT_FIELDS, 'group')['filter']}
                                                enableEdit={true}
                                                fieldClassName={'w-1/2'}/>
                                        </div>
                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-blueGray-200 rounded-b">
                                    <div className="ml-4 -mt-1">
                                        <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                                    </div>
                                    <button
                                        className="ml-2 text-gray-500 font-bold border border-gray-500 h-10 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-10 rounded px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Blog Post
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default AddEditBlogPost
